import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import ICON_SIZES_STYLES from 'constants/styles/ICON_SIZES_STYLES';
import theme from 'styles/theme';

const useStyles = makeStyles<{ isBoxShadow: boolean }>()((_, { isBoxShadow }) => ({
  root: {
    width: `${ICON_SIZES_STYLES.large.width} !important`,
    height: `${ICON_SIZES_STYLES.large.height} !important`,
    borderRadius: '50%',
    backgroundColor: theme.palette.warning.main,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: isBoxShadow ? `0 8px 16px ${alpha(theme.palette.warning.main, 0.3)} !important` : 'none',
  },
}));

export default useStyles;
